export default {
  getLocations: state => state.locations,
  getSettingsSearch: state => state.settingsSearch,
  getLocationHasClinicians: state => state.locationHasClinicians,
  getSettingEditingInForm: state => state.settingEditingInForm,
  getStates: state => state.states
}
